<div class="phone-prefix-input">
  <ng-content select="vc-phone-prefix-dropdown"></ng-content>
</div>
<div class="phone-number-input">
  <ng-content select="vc-text-input"></ng-content>
</div>
